import { Skeleton } from '@shared/components/shadcn';

type LoadingPodsSkeletonProps = {
  showDetailsRow?: boolean;
};

function LoadingPodsSkeleton({ showDetailsRow = true }: LoadingPodsSkeletonProps) {
  return (
    <div className="ll-container-inner flex flex-col gap-3" data-testid="loading-pods-skeleton">
      {Array.from({ length: 5 }).map((_, index) => (
        <Skeleton key={index} className="isolate relative bg-background border border-border rounded-lg overflow-hidden " data-testid="loading-pods-skeleton-item">
          <div className="p-5 flex items-center gap-5 opacity-50">
            <Skeleton className="size-10.5 rounded-full shrink-0" />
            <div className="w-full flex flex-col gap-2">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-4 w-20" />
            </div>
            <Skeleton className="h-6 w-24 absolute top-0 right-0 rounded-r-none" />
          </div>
          {showDetailsRow ? <Skeleton className="h-8.5 w-full opacity-50 rounded-none" data-testid="loading-pods-skeleton-footer" /> : null}
        </Skeleton>
      ))}
    </div>
  );
}

export { LoadingPodsSkeleton };
